import { render, staticRenderFns } from "./notCompeleteSupervision.vue?vue&type=template&id=15f5b054&scoped=true"
import script from "./notCompeleteSupervision.vue?vue&type=script&lang=js"
export * from "./notCompeleteSupervision.vue?vue&type=script&lang=js"
import style0 from "./notCompeleteSupervision.vue?vue&type=style&index=0&id=15f5b054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f5b054",
  null
  
)

export default component.exports